import React, {Component, Fragment} from 'react';
import SelectField from '../Fields/SelectField';
import InputField from '../Fields/InputField';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';

class MediaFilter extends Component {

    constructor(props) {
        super(props);
        this.onFilterChange = this.onFilterChange.bind(this);
    }

    onFilterChange(value, field) {
        if (this.props.onFilterChange) {
            this.props.onFilterChange(value, field)
        }
    }

    render() {
        const {
            fileTypes,
            filterMediaTypeEnabled,
            filteredMediaType,
            filteredKeyword,
            filteredWorkspace,
            workspace
        } = this.props;

        return (
            <Fragment>

                <div className={classNamesPrefixed({"media-filter": true})}>
                    <div className={classNamesPrefixed({'form-item': true,})}>
                        <InputField
                            omitCollapsible={true}
                            meta={{
                                touched: false,
                                error: null
                            }}
                            id="filtredKeyword"
                            name="filteredKeyword"
                            type={"search"}
                            icon={"search"}

                            input={{
                                onChange: (event) => this.onFilterChange(event.target.value, 'filteredKeyword'),
                                value: filteredKeyword
                            }}
                            placeholder={"Filter by keyword"}
                        />
                    </div>
                    {workspace && workspace.items && workspace.items.length > 1 &&
                    <div className={classNamesPrefixed({'form-item': true, 'form-text': true})}>
                        <SelectField
                            omitCollapsible={true}
                            meta={{
                                touched: false,
                                error: null
                            }}
                            id="filteredWorkspace"
                            name="filteredWorkspace"
                            items={workspace.items}
                            input={{
                                onChange: (value) => {
                                    this.onFilterChange(value, 'filteredWorkspace')
                                },
                                value: filteredWorkspace
                            }}
                            placeholder={"Select workspace"}
                            clearable={true}
                        />
                    </div>
                    }
                    {fileTypes && filterMediaTypeEnabled &&
                    <div className={classNamesPrefixed({'form-item': true, 'form-text': true})}>
                        <SelectField
                            omitCollapsible={true}
                            meta={{
                                touched: false,
                                error: null
                            }}
                            id="filteredMediaType"
                            name="filteredMediaType"
                            items={fileTypes}
                            input={{
                                onChange: (value) => {
                                    this.onFilterChange(value, 'filteredMediaType')
                                },
                                value: filteredMediaType
                            }}
                            placeholder={"Select media type"}
                            clearable={true}
                        />
                    </div>
                    }
                </div>
            </Fragment>
        )
    }
}


export default MediaFilter;



// WEBPACK FOOTER //
// ./src/core/admin/components/Forms/MediaFilter.js